import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    visuallyHidden: theme.visuallyHidden,
    activeSortLabel: {
        color: `${theme.palette.primary.main} !important`
    }
}));
